<template>
  <div class="d-flex flex-column"
       style="width: 100%">


    <div
      v-if="items && items.length > 0"
      class="d-flex flex-column mt-3">
      <v-card v-for="item in items"
              :key="'item-'+item.book_id"
              class="d-flex mb-6" flat
              color="transparent"
      >


        <img
          @click="onSelectSubject(item.book_id)"
          class="rounded-lg align-self-start"
          style="width: 100%; cursor: pointer; object-fit: contain !important;"
          :style="isCheckout ? 'max-width: 75px' : 'max-width: 125px'"
          :src="item.image"
        >

        <div class="d-flex flex-column mt-1 ml-4" style="flex: 1">

          <div
            class="d-flex align-start">
            <!-------- DOSSIER NAME ---------->
            <div style="flex: 1">
            <span
              @click="onSelectSubject(item.book_id)"
              style="cursor: pointer; font-size: 16px; flex: 1; max-width: 200px;"
              class="font-rubik font-weight-medium">{{ item.new_subject_name || item.subject_name }}</span>
            <span v-if="/^(notes|pack)(Color)?$/.test(item.kind || '')" class="d-block font-rubik" style="font-size: 13px; color: #1B8F5D">
              {{ /^pack/.test(item.kind) ? 'Pack exàmens + apunts' : 'Apunts definitius' }}
            </span>
            <!-- Volum 2… del quadern d'exàmens (products.js: volume, volumes) -->
            <span v-if="item.volume > 1" class="d-block font-rubik" style="font-size: 13px; color: #1B8F5D">
              Volum {{ item.volume }}<template v-if="volumeYears(item)"> · exàmens {{ volumeYears(item) }}</template>
            </span>
            <!-- Apunts: canviar entre blanc i negre i color des de la cistella (la germana a color és un altre llibre) -->
            <span v-if="printPair(item)" class="print-pick font-rubik" role="radiogroup" aria-label="Tipus d'impressió">
              <button v-for="opt in printPair(item)" :key="opt.book.book_id" type="button" role="radio"
                      :aria-checked="String(opt.book.book_id === item.book_id)" class="print-pick-opt"
                      :class="{ 'print-pick-opt--on': opt.book.book_id === item.book_id }" @click="pickPrint(item, opt.book)">
                {{ opt.color ? '🎨 A color' : 'B/N' }} · {{ String(opt.book.price).replace('.', ',') }} €
              </button>
            </span>
            </div>


            <!-------- DISCOUNT PRICE ---------->
            <div class="d-flex flex-column align-end">
                <span
                  v-if="item.oldPrice"
                  class="font-weight-regular font-rubik ml-3"
                  style="font-size: 16px !important; text-decoration: line-through"
                >
                  {{ item.oldPrice }}€
                </span>

              <!--------  PRICE ---------->
              <span
                v-if="item && item.price"
                class="font-weight-regular font-rubik font-weight-medium"
                    :style="item.oldPrice ? 'color: red; font-size: 12px !important' : ''"
                    style="font-size: 16px !important;">{{ item.price }}€</span>

            </div>
          </div>

          <div class="d-flex align-center">
            <!-------- PAGES ---------->
            <span class="mb-2 mt-1 font-rubik" style="font-size: 14px">{{ item.pages }} pàg.</span>

            <v-spacer></v-spacer>

            <!--------  PRICE ---------->
            <span
              v-if="isCheckout"
              class="font-rubik"
              style="font-size: 14px"
            >
                  {{ item.quantity }} u.
                </span>
          </div>


          <!-------- QUANTITY SELECTOR ---------->

          <div
            v-if="!isCheckout"
            class="d-flex align-center mt-0 mb-2">
            <v-card :ripple="false"
                    class="text-center justify-center pa-0 no-background-hover font-rubik mt-1"
                    style="font-size: 12px !important;"
                    small text flat
                    @click="decreaseQuantity(item.book_id)">
              ELIMINAR
            </v-card>

            <v-spacer></v-spacer>

            <div class="d-flex flex-column">
                <span style="font-size: 14px">
                  Quantitat:
                </span>
              <div class="d-flex align-center">
                <v-icon x-small
                        @click="decreaseQuantity(item.book_id)"
                        icon class="font-weight-medium mr-2" color="black">
                  {{ mdiMinus }}
                </v-icon>
                <span class="font-rubik"
                      style="font-size: 14px"
                >
                    {{ item.quantity }}</span>
                <v-icon x-small
                        @click="increaseQuantity(item.book_id)"
                        icon
                        class="font-weight-medium ml-2"
                        color="black"
                >
                  {{ mdiPlus }}
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-------- ENVIAMENT GRATIS: quant hi falta ---------->
      <free-shipping-progress :items="items"></free-shipping-progress>

      <!-------- PACK (quadern + apunts) per a qui en compra només un ---------->
      <pack-upsell :items="items"></pack-upsell>

      <!-------- SHIPPINGS ---------->
      <v-card
        v-if="shippings2 && shippings2.length && shippings2[selectedShipment] && shippings2[selectedShipment].price > 0"
        :key="refreshPrice + '-envio-price'"
        flat color="transparent"
        class="rounded-lg align-center d-flex font-rubik mt-4"
        height="36"
        style="font-size: 14px"
      >
        <span style="flex: 1">
        Envío {{ shippings2[selectedShipment].title }}
        </span>
        <span
          class="font-weight-medium"
          style="font-size: 12px">{{ shippings2[selectedShipment].price.toFixed(2) }} €</span>
      </v-card>


      <!---- TOTAL PRICE ----->
      <div class="d-flex mt-4" style="font-size: 14px">
        <span class="font-weight-medium font-rubik">Total:</span>
        <v-spacer></v-spacer>

        <!-------- DISCOUNT PRICE ---------->
        <div class="d-flex flex-column align-end">
                    <span
                      v-if="totalOldPrice() !== total()"
                      class="font-weight-regular font-rubik ml-3"
                      style="font-size: 14px !important; text-decoration: line-through"
                    >
                      {{ totalOldPrice().toFixed(2) }}€
                    </span>

          <!--------  PRICE ---------->
          <span class="font-weight-medium font-rubik"
                :style="totalOldPrice() !== total() ? 'color: red; font-size: 15px !important' : ''"
                style="font-size: 15px !important;">{{ total().toFixed(2) }}€</span>
        </div>
      </div>

      <div class="text-center mt-4">
      </div>

    </div>

  </div>
</template>

<script>

import {mdiMinus, mdiPlus} from "/src/assets/mdi.json";
import PackUpsell from "./PackUpsell.vue";
import FreeShippingProgress from "./FreeShippingProgress.vue";
import {applyFreeShipping, offerState} from "../../freeShipping";
import {addToCart, removeFromCart, swapInCart} from "../cart";

export default {
  name: "CheckoutItems",
  components: {PackUpsell, FreeShippingProgress},
  props: {
    items: Array,
    allBooks: Array,
    shippings: Array,
    selectedShipment: {
      type: Number,
      default: null
    },
    isCheckout: {
      type: Boolean,
      default: false
    }
  },
  metaInfo() {
    return {
      title: `Dossiers de la Selectivitat 2025`,
      meta: [
        {charset: 'utf-8'},
        {
          vmid: 'description', name: 'description',
          content: `Els dossiers de la selectivitat són el material idoni per estudiar per les PAU sense perdre el temps. Problemes classificats per temes i solucions al costat per autocorregir-te.`
        },
        {name: 'viewport', content: 'width=device-width, initial-scale=1'}
      ]
    }
  },
  async created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    if (!this.isCheckout) this.fetchShippings()
  },
  data() {
    return {
      refreshBooks: 0,
      selectedShipping: 0,
      email: null,
      mobil: null,
      dni: null,
      url: process.env.VUE_APP_AXIOS_URI,
      isUserScrolling: false,
      postalCode: null,
      sessionid: null,

      loading: false,
      loadingCode: false,
      lineItems: [],
      minShippingPrice: 0,
      refreshPrice: 0
    }
  },
  computed: {
    // Enviament gratis personal (correu de cistella abandonada): en arribar o caducar, es recalcula l'enviament
    freeShippingOffer() {
      return offerState.offer
    },
    shippings2: {
      get() {
        return this.shippings
      },
      set(val) {
        this.$emit("update:shippings", val);
      }
    },
    cart() {
      return this.$root.cart
    },
    columns() {
      const dim = this.$vuetify.breakpoint.name;
      if (dim === 'xs')
        return 3;
      else if (dim === 'sm')
        return 4;
      else if (dim === 'md')
        return 6;
      else if (dim === 'lg')
        return 8;
      else (dim === 'xl')
      return 6;

    },
    mdiPlus() {
      return mdiPlus
    },
    mdiMinus() {
      return mdiMinus
    },
  },
  methods: {
    /** «2016–2022»: els anys del volum del quadern */
    volumeYears(item) {
      const v = (item.volumes || []).find(x => x.volume === item.volume)
      return v ? `${v.from}–${v.to}` : ''
    },
    /** El llibre en B/N i el de color (quadern, apunts o pack; kind '<kind>Color' amb colorOf), si es ven a color */
    printPair(item) {
      if (!item || !/^(exams|examsVol|notes|pack)(Color)?$/.test(item.kind || '') || !this.allBooks) return null
      const all = this.allBooks.flatMap(b => (b && (b.subjects || b.apunts) ? [...(b.subjects || []), ...(b.apunts || [])] : [b]))
      const isColor = /Color$/.test(item.kind)
      const bw = isColor ? all.find(b => b && b.book_id === item.colorOf) : all.find(b => b && b.book_id === item.book_id) || item
      const color = isColor ? item : bw && all.find(b => b && b.colorOf === bw.book_id && /Color$/.test(b.kind || ''))
      return bw && color ? [{ book: bw, color: false }, { book: color, color: true }] : null
    },
    pickPrint(item, book) {
      if (book.book_id !== item.book_id) swapInCart(this, item.book_id, book.book_id)
    },
    async submit() {
      // await this.axios.post("/shop/payment", {
      //   status: 'INCOMPLETE',
      //   dni: this.dni,
      //   email: this.email,
      //   mobile: this.mobil
      // })

      this.lineItems = [];

      for await (let item of this.items) {
        for await (let offer of item.offers) {
          const {data} = await this.axios.get(`/book/stripe-key/${item.book_id}/${offer}`)

          let idx = this.lineItems.findIndex(item => item.price === data.stripe_key)
          if (idx == -1) {
            this.lineItems.push({
              price: data.stripe_key, // The id of the one-time price you created in your Stripe dashboard
              quantity: 1,
            })
          } else {
            this.lineItems[idx].quantity++;
          }
        }
      }


      const shipping = this.shippings2[this.selectedShipping];
      const shippingPrice = Math.round(shipping.price * 100);
      if (shippingPrice > 0) {
        const {data} = await this.axios.get(`/shipping/stripe-key/${shippingPrice}/${shipping.Name}`)
        if (!data || data.length === 0) alert("Si us plau, fes una foto de la pantalla posat en contacte amb examenselectivitat per acabar la teva comanda. contacte@examenselectivitat.cat")
        this.lineItems.push({
          price: data.stripe_key, // The id of the one-time price you created in your Stripe dashboard
          quantity: 1,
        })
      }

      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
    roundNumber(number) {
      return Math.round(number * 100) / 100
    },
    total() {
      let sum = 0;
      this.items.forEach(item => {
        sum += item.quantity * item.price;
      })

      if (this.selectedShipment !== null && this.shippings2[this.selectedShipment])
        sum += this.shippings2[this.selectedShipment].price

      return this.roundNumber(sum);
    },
    totalOldPrice() {
      let sum = 0;
      this.items.forEach(item => {
        sum += item.quantity * (item.oldPrice ? item.oldPrice : item.price);
      })

      if (this.selectedShipment !== null && this.shippings2[this.selectedShipment])
        sum += this.shippings2[this.selectedShipment].price

      return this.roundNumber(sum);
    },
    toDiscount() {
      let sum = 0;
      this.items.forEach(item => {
        sum += item.quantity;
      })
      return 5 - sum;
    },
    setOffers() {

      // Set values to default
      let totalQuantity = 0;
      this.items.forEach(item => {
        item.offers = [];
        item.offerPrices = {
          offer: 0,
          normal: item.quantity
        };

        for (let i = 0; i < item.quantity; i++) {
          item.offers[i] = false;
        }
        totalQuantity += item.quantity;
      });

      // const withOffer = Math.floor(totalQuantity / 3) * 3;
      const withOffer = 0;
      // Apply offers by order
      let applied = 0;
      for (let i = 0; i < withOffer && applied < withOffer; i++) {
        for (let j = 0; j < this.items[i].quantity && applied < withOffer; j++) {
          this.items[i].offers[j] = true;
          applied++;
        }
      }

      // Merge into groups -> [0]: 8,75 or [1]: 6,95
      this.items.forEach(item => {
        const offer = item.offers.filter(o => o).length;
        item.offerPrices = {
          offer: offer,
          normal: item.offers.length - offer
        };
      });
    },
    // La galeta i el total es toquen a cart.js; CartNav / el checkout reconstrueixen `items` amb 'cart-changed'
    deleteFromCart(book) {
      removeFromCart(this, book.book_id, true)
    },
    decreaseQuantity(book_id) {
      removeFromCart(this, book_id)
    },
    increaseQuantity(book_id) {
      addToCart(this, book_id)
    },
    handleScroll(event) {
      this.isUserScrolling = (window.scrollY > 80);
    },
    async onSelectSubject(book_id) {
      this.$router.push({path: '/dossiers-selectivitat/book/' + book_id})
    },
    async fetchShippings() {
      this.loadingCode = true;
      let pages = 0;
      let price = 0;
      let totalQuantity = 0;
      this.items.forEach(item => {
        price += (item.pages * 0.02 + 0.08) * item.quantity;
        pages += item.pages * item.quantity;
        totalQuantity += item.quantity;
      })

      pages = Math.round(pages / 2);

      const {data} = await this.axios.get(`/shop/shipping/${pages}`, {
        params: {books: this.items.map(i => `${i.book_id}:${i.quantity}`).join(',')}
      })
      this.shippings2 = await applyFreeShipping(data, this.items)
      this.$emit("update:selectedShipment", 0)
      this.refreshPrice++


      this.minShippingPrice = Math.min(...this.shippings2.map(s => s.price))


      this.loadingCode = false;
    },
    offerImage() {
      return this.url + '/images/other/OfertaBooklets.png'
    },
    offerImageSm() {
      return this.url + '/images/other/OfertaBooklets_sm.png'
    }
  },
  watch: {
    freeShippingOffer() {
      this.fetchShippings()
    },
    async items(val) {
      // Al checkout l'enviament el calcula CheckOutPage (amb la província i l'opció triada)
      if (!this.isCheckout) await this.fetchShippings()
    }
  }
}
</script>

<style scoped>
.post-code-input >>> label {
  font-size: 14px !important;
}

.post-code-input >>> .v-label--active {
  top: -5px !important;
}

/* Apunts: blanc i negre o a color (el triat amb la vora verda) */
.print-pick { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px; }
.print-pick-opt {
  padding: 2px 9px; border-radius: 10px; border: 2px solid #e0e0e0; border-bottom-width: 3px; background: #fff;
  font-size: 12px; font-weight: 600; color: #666; cursor: pointer; white-space: nowrap;
}
.print-pick-opt--on { border-color: #1B8F5D; background: #eef8f2; color: #222; }
</style>
